export default function ($translate) {
    return {
        KEYS: {
            MANDATORY: 'MANDATORY',
            OPTIONAL: 'OPTIONAL'
        },
        LABELS: {
            MANDATORY: $translate.instant('general.Yes'),
            OPTIONAL: $translate.instant('general.No')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/trainingPassingType/index.js